import Type from "@/model/types/Type";

const type = {
    ONLY_VIEW : 1,
    INSERT_OR_UPDATE : 2,
    ALL : 3,
}

const list = [
    {
        value: type.ONLY_VIEW,
        text: "Somente visualização",
    },
    {
        value: type.INSERT_OR_UPDATE,
        text: "Insere ou Altera",
    },
    {
        value: type.ALL,
        text: "Acesso Completo",
    },


]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}


